module.exports = __webpack_public_path__ + "img/paibei_92b5c4e06.png";